module.exports = __webpack_public_path__ + "img/f_twitter.40232e79.svg";